import { CantileverButton } from 'components/CantileverButton'
import { useKestrelViewerContext } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'

import {
  ButtonContainer,
  SettingsTooltipContainer,
  SettingsTooltipOverlay,
  TooltipArrowLeft,
  TooltipBox,
  TooltipText,
  TooltipTitle,
} from './TutorialStyledComponents'

interface SettingsTooltipProps {
  onNext: () => void
  onPrevious: () => void
}

export const SettingsTooltip: React.FC<SettingsTooltipProps> = ({
  onNext,
  onPrevious,
}) => {
  const { setSettingsOpen } = useKestrelViewerContext()

  const handleNext = () => {
    setSettingsOpen(false)
    onNext()
  }

  const handlePrevious = () => {
    setSettingsOpen(false)
    onPrevious()
  }

  useEffect(() => {
    setSettingsOpen(true)
    // close settings when component unmounts
    return () => {
      setSettingsOpen(false)
    }
  }, [setSettingsOpen])

  // using a portal to allow the z-index to be above the modal backdrop
  return createPortal(
    <SettingsTooltipOverlay>
      <SettingsTooltipContainer>
        <TooltipBox>
          <TooltipArrowLeft />
          <TooltipTitle>Settings</TooltipTitle>
          <TooltipText>
            User settings allow you to customize your user experience within
            Kestrel. User settings will be saved across models.
            <br />
            <br />
            Scene settings allow you to change how you are interacting with the
            model.
            <br />
            <br />
            You can always redo the tutorial from here!
          </TooltipText>
          <ButtonContainer style={{ marginTop: '1rem' }}>
            <CantileverButton onClick={handlePrevious}>
              Previous
            </CantileverButton>
            <CantileverButton primary onClick={handleNext}>
              Finish
            </CantileverButton>
          </ButtonContainer>
        </TooltipBox>
      </SettingsTooltipContainer>
    </SettingsTooltipOverlay>,
    document.body
  )
}
